import { useTranslation } from "react-i18next";
import { Modifydetail } from "../../../../../../redux/apiSpecifications/apiCrud";

interface IPracticeNoteCreatedDescriptionProps {
  modifyDetailsJson: Modifydetail[];
}

const PracticeNoteCreatedDescription = ({
  modifyDetailsJson,
}: IPracticeNoteCreatedDescriptionProps) => {
  const { t } = useTranslation();

  const practice_note = modifyDetailsJson.find(
    (_) => _.key === "practice_note"
  );

  return <> {t(`historical-actions-practice-note-created-description`, {
    practice_note: practice_note?.value ?? "",
  })}</>;
};
export default PracticeNoteCreatedDescription;
